// @ts-nocheck
(function () {
  'use strict';

  var STAR_PATH = 'm10.344 14.899 3.937 2.5c.508.32 1.133-.157.985-.743l-1.141-4.484a.68.68 0 0 1 .227-.688l3.53-2.945c.462-.383.227-1.156-.374-1.195l-4.61-.297a.648.648 0 0 1-.57-.422L10.61 2.297a.649.649 0 0 0-1.218 0L7.67 6.625a.648.648 0 0 1-.57.422l-4.609.297c-.601.039-.836.812-.375 1.195l3.531 2.945a.68.68 0 0 1 .227.688L4.82 16.328c-.18.703.57 1.274 1.172.89l3.664-2.32a.64.64 0 0 1 .688 0Z';

  // Keep in step with the `size` passed to rating-stars in the review card.
  var RV_STAR_SIZE = 22;

  /*
   * How far past the film heading's entry the takeover runs, in viewports. The
   * heading is gated on the takeover and paced by its own travel, so this is
   * the window in which both are moving at once.
   */
  var HANDOFF_OVERLAP = 0.5;

  /*
   * Ceiling on the viewport height the scroll TRACK is built from. The stage itself
   * still fills the window; this only bounds the empty runway the sticky stage
   * travels against, which is otherwise a straight multiple of window height — so a
   * tall monitor paid for the same animation twice over. Above this, the sequence
   * advances at a constant rate instead of stretching.
   */
  var TRACK_UNIT_CAP = 900;

  function clamp01(value) {
    return Math.max(0, Math.min(1, value));
  }

  /*
   * iOS collapses and re-expands its URL bar as you scroll, and every step of that
   * animation is a resize event carrying a new innerHeight. Re-laying the scene out
   * mid-scroll is what makes the pinned heading hop, so the scene works from a
   * viewport height that only moves when the width does — a real rotation, or a
   * window drag on desktop — and ignores the bar entirely. Pairs with 100svh on the
   * stage, which is the same height this caches on first paint.
   */
  var IS_TOUCH_VIEWPORT =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  var viewportWidth = window.innerWidth;
  var viewportHeight = window.innerHeight;

  function stableViewportHeight() {
    return viewportHeight;
  }

  /* True only for a resize the scene should actually relayout for. */
  function viewportChanged() {
    var width = window.innerWidth;
    var height = window.innerHeight;
    if (width === viewportWidth && (IS_TOUCH_VIEWPORT || height === viewportHeight)) return false;
    viewportWidth = width;
    viewportHeight = height;
    return true;
  }

  /* An editor percentage read off a chip, as a fraction of the stage. */
  function chipFraction(element, attribute, fallback) {
    var raw = parseFloat(element.getAttribute(attribute));
    return Number.isFinite(raw) ? clamp01(raw / 100) : fallback;
  }

  function easeOut(value) {
    return 1 - Math.pow(1 - clamp01(value), 3);
  }

  function easeInOut(value) {
    value = clamp01(value);
    return value < 0.5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function FoldText(element, stagger) {
    this.element = element;
    this.stagger = stagger || 0.05;
    this.pieces = [];
    this.observer = null;
  }

  FoldText.prototype.mount = function (options) {
    if (!this.element || this.element.__inviziFoldMounted) return;
    this.element.__inviziFoldMounted = true;
    this.manual = !!(options && options.manual);
    var text = this.element.textContent || '';
    var element = this.element;
    element.textContent = '';
    element.style.whiteSpace = 'pre-wrap';

    text.split(/(\s+)/).forEach(function (unit) {
      if (!unit) return;
      if (/^\s+$/.test(unit)) {
        element.appendChild(document.createTextNode(unit));
        return;
      }
      var outer = document.createElement('span');
      var inner = document.createElement('span');
      outer.className = 'invizi-fold__piece';
      inner.className = 'invizi-fold__face';
      inner.textContent = unit;
      outer.appendChild(inner);
      element.appendChild(outer);
      this.pieces.push(inner);
    }, this);

    if (this.manual) return;

    var self = this;
    this.observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      self.observer.disconnect();
      self.unfold();
    }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });
    this.observer.observe(element);
  };

  FoldText.prototype.unfold = function () {
    if (this.unfolded) return;
    this.unfolded = true;
    if (this.observer) this.observer.disconnect();
    var stagger = this.stagger;
    this.pieces.forEach(function (piece, index) {
      var delay = (index * stagger).toFixed(3) + 's';
      piece.classList.add('is-animating');
      piece.style.transition = 'transform .65s cubic-bezier(.16,1,.3,1) ' + delay + ',opacity .65s ease ' + delay;
    });
    var pieces = this.pieces;
    var element = this.element;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        pieces.forEach(function (piece) {
          piece.style.transform = 'rotateX(0deg)';
          piece.style.opacity = '1';
        });
      });
    });
    var last = pieces[pieces.length - 1];
    if (!last) return;
    var flattened = false;
    var flatten = function () {
      if (flattened) return;
      flattened = true;
      last.removeEventListener('transitionend', clear);
      pieces.forEach(function (piece) {
        piece.classList.remove('is-animating');
        piece.style.transition = '';
        piece.style.transform = '';
        piece.style.opacity = '';
        piece.classList.add('is-done');
        if (piece.parentNode) piece.parentNode.classList.add('is-done');
      });
      if (element) element.classList.add('is-fold-done');
    };
    var clear = function (event) {
      if (event.propertyName && event.propertyName !== 'transform') return;
      flatten();
    };
    last.addEventListener('transitionend', clear);
    setTimeout(flatten, 650 + pieces.length * stagger * 1000 + 80);
  };

  FoldText.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
  };

  function CardStack(root, options) {
    this.root = root;
    this.options = options || {};
    this.scene = root.closest('[data-invizi-scene]');
    this.stage = root.querySelector(this.options.stageSelector);
    this.title = root.querySelector(this.options.titleSelector);
    this.cards = Array.prototype.slice.call(root.querySelectorAll(this.options.cardSelector));
    this.videos = this.options.video ? Array.prototype.slice.call(root.querySelectorAll('[data-video]')) : [];
    this.props = this.readProps();
    this.titleHeight = 0;
    this.titleOffsetTop = 0;
    this.titleLift = 0;
    this.offsets = [];
    this.inView = false;
    this.activeVideo = -1;
    this.lastTickProgress = null;
    this.lastTickTop = null;
    this.lastTitleExit = null;
    this.raf = 0;
    this.resizeTimer = 0;
  }

  CardStack.prototype.readProps = function () {
    var travel = parseFloat(this.root.getAttribute('data-card-travel'));
    var stagger = parseFloat(this.root.getAttribute('data-fold-stagger'));
    return {
      travel: isFinite(travel) ? travel : 0.8,
      stagger: isFinite(stagger) ? stagger : 0.05
    };
  };

  CardStack.prototype.mount = function () {
    var self = this;
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.dataQuery = window.matchMedia('(prefers-reduced-data: reduce)');

    /*
     * PERF-07 SF-03/SF-04: the stack is static in normal flow by default (the markup's
     * data-motion="static"). The sticky stack arms only while it is wholly below the
     * viewport (R2): arming grows the section into its scroll runway, which must not
     * move anything the reader can see. Until then, or for good in lite and with
     * reduced motion, it stays static and none of the scroll maths runs.
     */
    var reduced = this.motionQuery.matches || this.dataQuery.matches;
    this.staticView = true;
    this.root.setAttribute('data-motion', 'static');
    var allowed = (window.Shopify && window.Shopify.designMode) ||
      (!reduced && (!window.__perf || Boolean(window.__perf.allowMotion)));
    if (!allowed || !this.stage) {
      this.setup();
      return;
    }
    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || this.isBelowViewport()) {
      this.arm();
      return;
    }
    this.setup();
    this.armObserver = new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      if (entry.isIntersecting || !self.isBelowViewport()) return;
      self.armObserver.disconnect();
      self.armObserver = null;
      self.arm();
    });
    this.armObserver.observe(this.root);
  };

  CardStack.prototype.isBelowViewport = function () {
    return this.root.getBoundingClientRect().top >= window.innerHeight;
  };

  CardStack.prototype.arm = function () {
    var self = this;
    this.staticView = false;
    this.root.setAttribute('data-motion', 'armed');
    if (this.options.onArm) this.options.onArm();
    this.onPreferenceChange = function () { self.setup(); };
    if (this.motionQuery.addEventListener) this.motionQuery.addEventListener('change', this.onPreferenceChange);
    if (this.dataQuery.addEventListener) this.dataQuery.addEventListener('change', this.onPreferenceChange);

    var foldTarget = this.root.querySelector(this.options.foldSelector);
    if (foldTarget && !this.motionQuery.matches) {
      this.fold = new FoldText(foldTarget, this.props.stagger);
      this.fold.mount({ manual: !!this.options.foldWithEnter });
    }

    this.observer = new IntersectionObserver(function (entries) {
      self.inView = entries[0].isIntersecting;
      if (self.inView) {
        if (self.root.getAttribute('data-motion') === 'armed') self.root.setAttribute('data-motion', 'live');
        self.requestTick();
      } else if (self.options.video) {
        self.setActiveVideo(-1);
      }
    }, { rootMargin: '10% 0px' });
    this.observer.observe(this.root);

    this.setup();
    /*
     * Re-measured unconditionally once fonts settle. status can already read
     * 'loaded' here and still be wrong for this scene: it only reports pending
     * loads, and the scene mounts near the viewport, so its own faces may not
     * have been requested yet. Measuring against fallback metrics puts the
     * title's offset out, which is what paces its entrance.
     */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { self.setup(); });
    }
  };

  CardStack.prototype.isStatic = function () {
    return this.staticView || this.motionQuery.matches || this.dataQuery.matches;
  };

  CardStack.prototype.setup = function () {
    if (!this.stage) return;
    if (this.isStatic()) {
      this.root.style.height = 'auto';
      this.cards.forEach(function (card) {
        card.style.transform = '';
        card.style.opacity = '1';
      });
      if (this.title) this.title.style.removeProperty('--invizi-stack-title-exit');
      if (this.fold) this.fold.unfold();
      if (this.options.video) {
        // Static films are ordinary poster-videos (ambient; tap to play in lite).
        this.releaseVideos();
        this.enableStaticVideos();
      }
      if (this.options.onStatic) this.options.onStatic();
      return;
    }

    var mobile = window.innerWidth <= 767;
    /*
     * Pin the stage to the cached viewport height in px. 100svh is the right
     * unit in CSS, but reading offsetHeight back mid-scroll on iOS can disagree
     * with the scroll maths for a frame and the flex-centred heading hops. One
     * pixel value shared by layout and tick keeps them locked.
     */
    var stageHeight = stableViewportHeight();
    this.stage.style.height = stageHeight + 'px';
    this.titleHeight = this.title ? this.title.offsetHeight : 0;
    /*
     * Where the title rests, measured from the top of the section.
     *
     * offsetTop, not a pair of rects. Setup runs again on resize and on fonts.ready,
     * and by then the stage may be pinned and the title part way through its
     * entrance — rects carry both the sticky shift and the transform, and the value
     * comes back a whole scroll position too large. offsetTop is pure layout: the
     * stage is the offsetParent and the section's first child, so the title's place
     * inside it is the same number either way.
     */
    this.titleOffsetTop = this.title ? this.title.offsetTop : 0;
    /*
     * The title is flex-centred in a viewport-tall sticky stage, so it sits half a
     * screen below the top of the section. Published so the section can pull itself
     * up by it and land the heading a fixed distance under whatever precedes it,
     * rather than a fixed distance under its own empty top half.
     */
    this.root.style.setProperty('--invizi-films-title-offset', Math.round(this.titleOffsetTop) + 'px');
    var gap = this.options.video ? (mobile ? 52 : 80) : (mobile ? 24 : 40);
    var offset = 0;
    this.offsets = [];

    this.cards.forEach(function (card, index) {
      if (index > 0) {
        var previous = this.cards[index - 1];
        var cardGap = gap;
        // Extra runway before the reviews CTA so the button sits clear of the last card.
        if (card.hasAttribute('data-cta')) cardGap += 40;
        offset += previous.offsetHeight / 2 + cardGap + card.offsetHeight / 2;
      }
      this.offsets.push(offset);
    }, this);

    var lastCard = this.cards[this.cards.length - 1];
    var lastHeight = lastCard ? lastCard.offsetHeight : 0;
    // Runway only: the visible stage below is still the real viewport height.
    var trackUnit = Math.min(stageHeight, TRACK_UNIT_CAP);
    var endRunway = 80;
    if (lastCard && lastCard.hasAttribute('data-cta')) endRunway += 40;
    this.distance = offset + trackUnit * 1.35 + lastHeight / 2 + endRunway;
    var speed = (mobile ? 0.78 : 0.88) / Math.max(0.8, this.props.travel);
    this.root.style.height = Math.round(stageHeight + this.distance / speed) + 'px';

    if (this.options.onLayout) this.options.onLayout(this);
    this.lastTickProgress = null;
    this.lastTickTop = null;
    this.lastTitleExit = null;
    this.tick();
  };

  /** Hand the managed films back to the media contract (SF-03). */
  CardStack.prototype.releaseVideos = function () {
    this.activeVideo = -1;
    this.cards.forEach(function (card) {
      card.classList.remove('is-active');
      var pv = card.querySelector('[data-poster-video][data-pv-managed]');
      if (!pv || pv.__stackState === null || pv.__stackState === undefined) return;
      pv.__stackState = null;
      pv.dispatchEvent(new CustomEvent('pv:manage', { detail: { state: null } }));
    });
  };

  CardStack.prototype.enableStaticVideos = function () {
    this.videos.forEach(function (video) {
      this.hydrateVideo(video);
      video.pause();
      video.setAttribute('controls', '');
      video.removeAttribute('tabindex');
      video.removeAttribute('aria-hidden');
    }, this);
  };

  /**
   * Pick the smallest data-width source that still covers the painted box.
   * When Liquid only exposes one 1080p mp4 this is a no-op; when 480/720 appear
   * it stops decoding Full HD into a ~450px film card.
   */
  CardStack.prototype.pickRenditions = function (video) {
    var sources = Array.prototype.slice.call(
      video.querySelectorAll('source[data-src][data-width]')
    );
    if (sources.length < 2) return sources;

    var coarse = window.matchMedia('(pointer: coarse)').matches;
    var ratio = Math.min(window.devicePixelRatio || 1, coarse ? 1.5 : 2);
    var painted = video.getBoundingClientRect().width || window.innerWidth;
    var target = painted * ratio;

    var ascending = sources.slice().sort(function (a, b) {
      return Number(a.dataset.width) - Number(b.dataset.width);
    });
    var best = ascending.find(function (source) {
      return Number(source.dataset.width) >= target;
    });
    return [best || ascending[ascending.length - 1]];
  };

  CardStack.prototype.hydrateVideo = function (video) {
    if (!video || video.hasAttribute('data-hydrated')) return;
    var sourceChanged = false;
    if (video.dataset.src) {
      video.src = video.dataset.src;
      sourceChanged = true;
    }

    var widthSources = video.querySelectorAll('source[data-src][data-width]');
    if (widthSources.length) {
      this.pickRenditions(video).forEach(function (source) {
        if (!source.getAttribute('src')) {
          source.src = source.dataset.src;
          sourceChanged = true;
        }
      });
    } else {
      Array.prototype.slice.call(video.querySelectorAll('source[data-src]')).forEach(function (source) {
        source.src = source.dataset.src;
        sourceChanged = true;
      });
    }

    video.setAttribute('data-hydrated', '');
    if (sourceChanged) {
      /*
       * Hold the element transparent over its poster until there is a frame to show.
       * Every outcome clears the class, including error, so a video is never left
       * invisible if a source fails or an event does not arrive.
       */
      var events = ['loadeddata', 'canplay', 'playing', 'error'];
      var reveal = function () {
        video.classList.remove('is-loading');
        events.forEach(function (name) { video.removeEventListener(name, reveal); });
      };
      video.classList.add('is-loading');
      events.forEach(function (name) { video.addEventListener(name, reveal); });
      try { video.load(); } catch (error) { reveal(); }
    }
  };

  /*
   * The film nearest the centre plays, the one after it is warmed, the rest pause. A
   * Shopify-hosted film is a poster-video, so the media contract still owns its <video>
   * (reveal on the first frame, decode slots, lite) and only takes the choice from here;
   * a card left behind unloads after 30 s rather than at once (SF-03).
   */
  CardStack.prototype.setActiveVideo = function (index) {
    if (index === this.activeVideo) return;
    this.activeVideo = index;
    this.cards.forEach(function (card, cardIndex) {
      var pv = card.querySelector('[data-poster-video][data-pv-managed]');
      var video = pv ? null : card.querySelector('[data-video]');
      if (cardIndex === index) card.classList.add('is-active');
      else card.classList.remove('is-active');
      if (pv) {
        var state = cardIndex === index ? 'active' : cardIndex === index + 1 ? 'warm' : 'idle';
        if (pv.__stackState === state) return;
        pv.__stackState = state;
        pv.dispatchEvent(new CustomEvent('pv:manage', { detail: { state: state } }));
        return;
      }
      if (!video) return;
      if (cardIndex === index) {
        this.hydrateVideo(video);
        video.setAttribute('preload', 'auto');
        var playPromise;
        try { playPromise = video.play(); } catch (error) { /* poster remains available */ }
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      } else if (cardIndex === index + 1) {
        /*
         * Arm the card the stack is about to raise so play() is not waiting on the
         * first bytes, which is what made the hand-off stall. One card ahead only,
         * and metadata rather than auto: enough for a first frame without pulling a
         * second whole file down the connection.
         */
        video.setAttribute('preload', 'metadata');
        this.hydrateVideo(video);
        try { video.pause(); } catch (error) { /* video was not ready */ }
      } else {
        video.classList.remove('is-loading');
        try {
          video.pause();
          video.currentTime = 0;
        } catch (error) { /* video was not ready */ }
        video.setAttribute('preload', 'none');
        // preload="none" after load() is a no-op — strip sources to release the decoder.
        if (video.hasAttribute('data-hydrated')) {
          if (video.getAttribute('src')) video.removeAttribute('src');
          Array.prototype.slice.call(video.querySelectorAll('source[src]')).forEach(function (source) {
            source.removeAttribute('src');
          });
          try { video.load(); } catch (error) { /* poster remains available */ }
          video.removeAttribute('data-hydrated');
        }
      }
    }, this);
  };

  CardStack.prototype.requestTick = function () {
    if (!this.inView || this.isStatic()) return;
    if (this.options.requestFrame) {
      this.options.requestFrame();
      return;
    }
    if (this.raf) return;
    var self = this;
    this.raf = requestAnimationFrame(function () {
      self.raf = 0;
      self.tick();
    });
  };

  CardStack.prototype.tick = function () {
    if (!this.stage || this.isStatic()) return;
    var rect = this.root.getBoundingClientRect();
    var stageHeight = stableViewportHeight();
    var span = Math.max(1, this.root.offsetHeight - stageHeight);
    /*
     * Lenis and resting trackpads emit ~1px scroll dust. That is enough to
     * change card transforms at toFixed(1) and rewrite style attributes every
     * frame, which makes DevTools thrash (and keeps html.lenis-scrolling hot).
     * Stick to the last committed top until motion clears a 2px deadzone.
     */
    /*
     * The dead zone below exists because Lenis and resting trackpads emit ~1px of
     * scroll dust, and recomputing the scene on it keeps everything hot for no
     * visible gain. But snapping to 2px snaps real motion too: a slow scroll moves
     * less than 2px per frame, so card progress sits still for several frames and
     * then hops. That hop is the judder, and on a 3x phone 2px is six device pixels
     * of it.
     *
     * The dust is a pointer-device problem, not a universal one — startSmoothScroll
     * never starts Lenis on '(hover: none) and (pointer: coarse)', and a phone has no
     * trackpad. So the zone is kept exactly where the dust is and coarse pointers
     * track the scroll as it really is. Same query as invizi-smooth-scroll.js, so the
     * two cannot drift apart.
     */
    var top = rect.top;
    if (this.scrollDeadZone == null) {
      this.scrollDeadZone =
        window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches
          ? 0
          : 2;
    }
    if (
      this.scrollDeadZone &&
      this.lastTickTop != null &&
      Math.abs(top - this.lastTickTop) < this.scrollDeadZone
    ) {
      top = this.lastTickTop;
    } else {
      this.lastTickTop = top;
    }
    var progress = clamp01(-top / span);
    if (this.title) {
      /*
       * Same path for film and review titles. Travel from just below the fold
       * to the resting sticky position — the film stack feeds this into the
       * ribbon handoff; reviews measure it the same way so both headings share
       * one scroll model. Neither stack writes a per-frame transform on the
       * title itself anymore (exit var was the shudder).
       */
      if (this.lastTitleExit !== '') {
        this.lastTitleExit = '';
        this.title.style.removeProperty('--invizi-stack-title-exit');
      }
      var runway = Math.max(1, stableViewportHeight() - this.titleOffsetTop);
      this.titleLift = clamp01(1 - top / runway);
    }
    if (this.options.onProgress) this.options.onProgress(progress, stageHeight, this);

    if (this.lastTickProgress != null && progress === this.lastTickProgress) {
      return;
    }
    this.lastTickProgress = progress;
    var nearestVideo = -1;
    var nearestDistance = Infinity;
    var nearestCard = -1;
    var nearestCardDistance = Infinity;

    this.cards.forEach(function (card, index) {
      var y = (this.offsets[index] || 0) + stageHeight * 0.85 - progress * this.distance;
      var side = Number(card.getAttribute('data-side')) || 0;
      var x = side * Math.min(1, Math.abs(y) / stageHeight) * (window.innerWidth <= 767 ? 10 : 22);
      var baseAngle = parseFloat(card.style.getPropertyValue('--card-angle')) || 0;
      var angleProgress = this.options.video ? Math.min(1, Math.abs(y) / (stageHeight * 0.5)) : 1;
      var angle = baseAngle * angleProgress;
      var transform = 'translate3d(' + x.toFixed(1) + 'px,calc(-50% + ' + y.toFixed(1) + 'px),0) rotate(' + angle.toFixed(3) + 'deg)';
      if (card.style.transform !== transform) card.style.transform = transform;
      if (card.style.opacity !== '1') card.style.opacity = '1';

      var centerDistance = Math.abs(y);
      if (centerDistance < nearestCardDistance) {
        nearestCardDistance = centerDistance;
        nearestCard = index;
      }

      if (this.options.video) {
        if (centerDistance < nearestDistance) {
          nearestDistance = centerDistance;
          nearestVideo = index;
        }
      }
    }, this);

    // Promote only the active card and its neighbours — Phase 1 dropped the
    // static will-change; this puts it back just-in-time for the cards that
    // are actually moving through the stage. Same for film and review stacks.
    this.cards.forEach(function (card, index) {
      card.classList.toggle('is-near', nearestCard >= 0 && Math.abs(index - nearestCard) <= 1);
    });

    if (this.options.video) {
      // Hysteresis so the active class does not flap at the engagement edge.
      var engage = stageHeight * (this.activeVideo >= 0 ? 0.64 : 0.58);
      this.setActiveVideo(nearestDistance <= engage ? nearestVideo : -1);
    }
  };

  // Alias used by Okendo after card HTML swaps — same work as setup, named so
  // call sites don't look like a full scene rebuild.
  CardStack.prototype.relayout = function () {
    this.setup();
  };

  CardStack.prototype.onResize = function () {
    var self = this;
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(function () { self.setup(); }, 150);
  };

  CardStack.prototype.destroy = function () {
    clearTimeout(this.resizeTimer);
    if (this.raf) cancelAnimationFrame(this.raf);
    if (this.armObserver) this.armObserver.disconnect();
    if (this.observer) this.observer.disconnect();
    if (this.fold) this.fold.destroy();
    if (this.onPreferenceChange) {
      if (this.motionQuery && this.motionQuery.removeEventListener) this.motionQuery.removeEventListener('change', this.onPreferenceChange);
      if (this.dataQuery && this.dataQuery.removeEventListener) this.dataQuery.removeEventListener('change', this.onPreferenceChange);
    }
    if (this.options.video) this.releaseVideos();
    this.root.setAttribute('data-motion', 'static');
  };

  function RibbonIntro(root, options) {
    this.root = root;
    this.options = options || {};
    this.stage = root.querySelector('[data-ribbon-stage]');
    // One finished drawing per breakpoint (SF-02); the script works on the one on screen.
    this.arts = Array.prototype.slice.call(root.querySelectorAll('[data-ribbon-art]'));
    this.bindArt(this.arts[0] || null);
    this.staticView = false;
    this.shadowInset = 0;
    this.pathRevealStep = null;
    this.chips = Array.prototype.slice.call(root.querySelectorAll('[data-ribbon-chip]'));
    this.items = [];
    this.clearanceSamples = [];
    this.pathSamples = [];
    this.revealGuide = [];
    this.pathLength = 1;
    this.artScale = 1;
    this.artOffsetX = 0;
    this.artOffsetY = 0;
    this.bandWidth = 180;
    this.crossStart = 0.8;
    this.variants = {};
    this.currentProgress = null;
    this.currentHandoff = null;
    this.lastContentOpacity = null;
    this.lastProgressAttr = null;
    this.lastHandoffAttr = null;
    this.lastFrameTime = 0;
    this.inView = false;
    this.resizeTimer = 0;
    this.readVariants();
  }

  RibbonIntro.prototype.bindArt = function (art) {
    this.art = art;
    var find = function (selector) { return art ? art.querySelector(selector) : null; };
    this.path = find('[data-ribbon-path]');
    this.outline = find('[data-ribbon-path-outline]');
    this.shadow = find('[data-ribbon-path-shadow]');
    this.overShadow = find('[data-ribbon-over-shadow]');
    this.basePaths = [this.shadow, this.outline, this.path];
    this.overPaths = [this.overShadow, find('[data-ribbon-over-outline]'), find('[data-ribbon-over-fill]')];
    this.strokePaths = this.basePaths.concat(this.overPaths);
  };

  /*
   * Armed, the drawing that does not match the breakpoint is set aside, so there is one
   * live copy to draw and measure. CSS showed the matching one until now, and still
   * would after a rotation, so swapping them back is invisible.
   */
  RibbonIntro.prototype.useArt = function (art) {
    if (!art) return;
    this.arts.forEach(function (other) {
      if (other === art || !other.isConnected) return;
      other.__ribbonSlot = other.__ribbonSlot || document.createComment('ribbon art');
      other.replaceWith(other.__ribbonSlot);
    });
    if (!art.isConnected && art.__ribbonSlot) art.__ribbonSlot.replaceWith(art);
    if (art !== this.art) {
      this.bindArt(art);
      this.pathRevealStep = null;
    }
  };

  RibbonIntro.prototype.restoreArts = function () {
    this.arts.forEach(function (art) {
      if (!art.isConnected && art.__ribbonSlot) art.__ribbonSlot.replaceWith(art);
    });
  };

  RibbonIntro.prototype.readVariants = function () {
    if (!this.arts.length) return;
    var self = this;
    Array.prototype.slice.call(this.root.querySelectorAll('[data-ribbon-geometry]')).forEach(function (node) {
      var key = node.getAttribute('data-ribbon-geometry');
      var box = String(node.getAttribute('data-view-box') || '').split(/[\s,]+/);
      var viewTop = parseFloat(node.getAttribute('data-view-top')) || 0;
      var viewBoxHeight = parseFloat(box[3]) || 1;
      self.variants[key] = {
        key: key,
        geometry: node,
        art: node.closest('[data-ribbon-art]'),
        viewBoxWidth: parseFloat(box[2]) || 1,
        // The drawn height, with the artwork's blank leading strip cropped off.
        viewBoxHeight: Math.max(1, viewBoxHeight - viewTop),
        viewTop: viewTop,
        fitWidth: parseFloat(node.getAttribute('data-fit-width')) || parseFloat(box[2]) || 1,
        focusX: parseFloat(node.getAttribute('data-focus-x')) || (parseFloat(box[2]) || 1) / 2,
        // Arc length rather than a fraction, so it stays put when the tail
        // length changes; the fraction is derived once the path is measured.
        crossAt: parseFloat(node.getAttribute('data-cross-at')) || 0,
        // The flow leaves through the side of the frame, so its last point is no
        // longer its lowest and cannot say where the draw finishes.
        finishY: parseFloat(node.getAttribute('data-finish-y')) || 0,
        handoffY: parseFloat(node.getAttribute('data-handoff-y')) || 0
      };
    });
  };

  RibbonIntro.prototype.mount = function () {
    var self = this;
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.dataQuery = window.matchMedia('(prefers-reduced-data: reduce)');

    /*
     * PERF-07 SF-02: the markup is the finished drawing, and the choreography only takes
     * over where nobody sees the swap (R2). Out of view either way is fine: below, it
     * starts undrawn; above, the script's first frame is the finished drawing again. While
     * the ribbon is on screen it waits, which also covers a page still settling above it
     * (at DOMContentLoaded a phone's heroes have no height yet). Lite and reduced motion
     * keep the drawing for good, and none of the layout below runs.
     */
    var reduced = this.motionQuery.matches || this.dataQuery.matches;
    this.staticView = true;
    this.root.setAttribute('data-motion', 'static');
    if (!this.allowsMotion(reduced)) {
      if (this.options.onStaticView) this.options.onStaticView(reduced);
      return;
    }
    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
      this.arm();
      return;
    }
    if (this.options.onStaticView) this.options.onStaticView(false);
    this.armObserver = new IntersectionObserver(function (entries) {
      if (entries[entries.length - 1].isIntersecting) return;
      self.armObserver.disconnect();
      self.armObserver = null;
      self.arm();
    });
    this.armObserver.observe(this.root);
  };

  RibbonIntro.prototype.arm = function () {
    var self = this;
    this.staticView = false;
    this.root.setAttribute('data-motion', 'armed');

    this.onPreferenceChange = function () { self.setup(); };
    if (this.motionQuery.addEventListener) this.motionQuery.addEventListener('change', this.onPreferenceChange);
    if (this.dataQuery.addEventListener) this.dataQuery.addEventListener('change', this.onPreferenceChange);

    /*
     * The takeover outlives the stage. It ends past the point where the heading
     * it hands off to enters the viewport, and the stage has left the top of the
     * screen well before that, so the margin above has to carry the flow through
     * the rest of the handoff. Without it the progress freezes part way and the
     * flow never finishes fading out.
     */
    this.observer = new IntersectionObserver(function (entries) {
      self.inView = entries[0].isIntersecting;
      if (self.inView) {
        if (self.root.getAttribute('data-motion') === 'armed') self.root.setAttribute('data-motion', 'live');
        self.requestTick();
        return;
      }
      /*
       * Settled against live geometry on the way out, rather than left wherever
       * the last frame put it. A scroll that clears the whole flow in one jump,
       * or a deep link past it, never runs the frames in between, and a flow
       * frozen half drawn is what the reader comes back to.
       */
      self.update(performance.now(), true);
    }, { rootMargin: '200% 0px 10% 0px' });
    this.observer.observe(this.root);
    this.root.classList.add('is-ready');
    this.prepareChips();
    this.setup();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { self.setup(); });
    }
  };

  /** The full tier without reduced motion; the theme editor always runs the choreography. */
  RibbonIntro.prototype.allowsMotion = function (reduced) {
    if (!this.stage || !this.arts.length) return false;
    if (window.Shopify && window.Shopify.designMode) return true;
    if (reduced) return false;
    return !window.__perf || Boolean(window.__perf.allowMotion);
  };

  RibbonIntro.prototype.isStatic = function () {
    return this.staticView || this.motionQuery.matches || this.dataQuery.matches;
  };

  RibbonIntro.prototype.setup = function () {
    if (this.staticView || !this.stage || !this.art || !this.path) return;
    this.setArtGeometry();
    this.buildPathMetrics();
    this.measureItems();
    this.layoutItems();
    this.buildRevealGuide();
    if (this.isStatic()) {
      // Drawn in full where it lies, since the scene it hands off to is placed
      // statically too.
      this.setPathReveal(1);
      this.root.style.setProperty('--invizi-ribbon-content-opacity', '1');
      this.updateItemReveal(true);
      if (this.options.onStatic) this.options.onStatic();
      return;
    }
    this.update(performance.now(), true);
  };

  RibbonIntro.prototype.prepareChips = function () {
    this.items = this.chips.map(function (chip) {
      return {
        element: chip,
        icon: chip.querySelector('[data-ribbon-chip-icon]'),
        text: chip.querySelector('[data-ribbon-chip-text]'),
        // Requested position as a fraction of the stage, per breakpoint, since
        // the two share no geometry.
        want: {
          desktop: {
            x: chipFraction(chip, 'data-chip-x', 0.1),
            y: chipFraction(chip, 'data-chip-y', 0.3)
          },
          mobile: {
            x: chipFraction(chip, 'data-chip-x-mobile', 0.1),
            y: chipFraction(chip, 'data-chip-y-mobile', 0.3)
          }
        },
        width: 0,
        height: 0,
        anchor: 0,
        placed: false,
        revealed: null
      };
    });
  };

  /*
   * The artwork only ever scales uniformly: the viewBox is sized to the stage's
   * own aspect ratio so preserveAspectRatio has nothing left to correct. Any
   * per-axis stretch here would turn the authored circular turns into ellipses
   * whose ends pinch tighter than the stroke, which is what produced the cusp.
   */
  RibbonIntro.prototype.setArtGeometry = function () {
    var variant = (window.innerWidth <= 767 && this.variants.mobile) || this.variants.desktop;
    if (!variant || !variant.geometry) return;
    this.useArt(variant.art);
    this.variant = variant;
    this.geometryPath = variant.geometry;
    this.pathLength = Math.max(1, this.geometryPath.getTotalLength());
    this.crossStart = clamp01(variant.crossAt / this.pathLength) || 0.8;

    var stageWidth = Math.max(1, this.stage.clientWidth);
    /*
     * Taller than the window, always. The draw is paced against depth, and it
     * has nowhere to run to if the artwork fits inside the viewport: on a narrow
     * but tall window, a tablet held upright above all, the fitted height falls
     * back to the floor while the window is taller still, and the flow finishes
     * drawing before the takeover it hands to has any scroll left to run in.
     */
    var minHeight = variant.key === 'mobile'
      ? Math.max(860, stableViewportHeight() * 1.2)
      : Math.max(1180, stableViewportHeight() * 1.35);
    var maxHeight = Math.max(minHeight, stableViewportHeight() * (variant.key === 'mobile' ? 1.55 : 1.8));
    var height = Math.min(maxHeight, Math.max(minHeight, variant.viewBoxHeight * stageWidth / variant.fitWidth));
    var scale = height / variant.viewBoxHeight;
    var viewWidth = stageWidth / scale;

    this.stage.style.height = Math.round(height) + 'px';
    this.art.setAttribute('viewBox', [
      (variant.focusX - viewWidth / 2).toFixed(2),
      variant.viewTop,
      viewWidth.toFixed(2),
      variant.viewBoxHeight
    ].join(' '));

    var pathData = variant.geometry.getAttribute('d');
    this.strokePaths.forEach(function (path) {
      if (path && path.getAttribute('d') !== pathData) path.setAttribute('d', pathData);
    });
    this.readArtMatrix();

    this.bandWidth = Number.parseFloat(getComputedStyle(this.outline).strokeWidth) || 180;
    var shadowOffset = this.readShadowOffset();
    this.shadowInset = shadowOffset * 1.3 / this.pathLength;
    this.publishTail(height, scale, variant, shadowOffset);
  };

  /*
   * Everything under the flow's lowest ink is dead scroll. The viewBox deliberately
   * runs on past the end of the path — that slack is what keeps the drawing at its
   * authored size once the stage is floored against the viewport — but nothing is
   * painted in it, so it reads as a screen of blank page. Publishing the leftover
   * lets the section below pull itself up by exactly that much.
   *
   * Measured off the stroke's outer edge, not the centreline it is drawn along,
   * since the edge is what the eye takes for the bottom of the flow.
   */
  RibbonIntro.prototype.publishTail = function (height, scale, variant, shadowOffset) {
    var scene = this.scene || (this.scene = this.root.closest('[data-invizi-scene]') || this.root);
    var box;
    try {
      box = this.path.getBBox();
    } catch (error) {
      return;
    }
    var inkBottom = box.y + box.height + this.bandWidth / 2 + shadowOffset;
    var tail = height - (inkBottom - variant.viewTop) * scale;
    scene.style.setProperty('--invizi-ribbon-tail', Math.round(Math.max(0, tail)) + 'px');
  };

  /* How far the shadow sub-stroke is pushed down the page, in viewBox units. */
  RibbonIntro.prototype.readShadowOffset = function () {
    if (!this.shadow) return 0;
    var transform = getComputedStyle(this.shadow).transform;
    if (!transform || transform === 'none') return 0;
    try {
      return Math.abs(new DOMMatrix(transform).f);
    } catch (error) {
      return 9;
    }
  };

  RibbonIntro.prototype.readArtMatrix = function () {
    var matrix = this.path && this.path.getScreenCTM ? this.path.getScreenCTM() : null;
    var stageRect = this.stage.getBoundingClientRect();
    this.artScale = matrix && matrix.a ? matrix.a : 1;
    this.artOffsetX = matrix ? matrix.e - stageRect.left : 0;
    this.artOffsetY = matrix ? matrix.f - stageRect.top : 0;
  };

  /* Arc position -> point plus unit tangent and normal, all in viewBox units. */
  RibbonIntro.prototype.userPointAt = function (distance) {
    var length = this.pathLength;
    var target = Math.max(0, Math.min(length, distance));
    var point = this.geometryPath.getPointAtLength(target);
    var ahead = this.geometryPath.getPointAtLength(Math.min(length, target + 2));
    var behind = this.geometryPath.getPointAtLength(Math.max(0, target - 2));
    var runX = ahead.x - behind.x;
    var runY = ahead.y - behind.y;
    var run = Math.hypot(runX, runY) || 1;
    return {
      x: point.x,
      y: point.y,
      tangentX: runX / run,
      tangentY: runY / run,
      normalX: -runY / run,
      normalY: runX / run
    };
  };

  RibbonIntro.prototype.buildPathMetrics = function () {
    var samples = [];
    var clearance = [];
    var length = this.pathLength;
    for (var index = 0; index <= 240; index++) {
      var progress = index / 240;
      var point = this.geometryPath.getPointAtLength(progress * length);
      samples.push({ progress: progress, y: point.y });
      clearance.push({ x: point.x, y: point.y });
    }
    this.pathSamples = samples;
    // Reused when scoring how far a candidate chip position sits from the band.
    this.clearanceSamples = clearance;
  };

  /*
   * Offset boxes rather than client rects: the icon starts scaled down and the
   * chip carries a translate, both of which a client rect would fold in. The
   * label keeps its natural width inside the clamped slot because a nowrap grid
   * item never shrinks below min-content, and the measurement is needed because
   * a width transition cannot animate toward auto.
   */
  RibbonIntro.prototype.measureItems = function () {
    this.items.forEach(function (item) {
      // A chip the previous layout could not place is only hidden, never removed
      // from layout, so it still measures at its natural size here.
      item.element.classList.remove('is-unplaced');
      var gap = Number.parseFloat(getComputedStyle(item.element).getPropertyValue('--invizi-chip-gap')) || 14;
      /*
       * offsetWidth is rounded to whole pixels, so a label whose content box is
       * 148.5px reports 148, the slot is sized to 148, and overflow:clip shaves the
       * right edge off the last glyph. A client rect would be fractional but folds in
       * the slot's pre-reveal scale(0.65), which is why offsetWidth is used at all —
       * so add back the pixel the rounding can hide rather than switching measure.
       */
      var textWidth = item.text ? item.text.offsetWidth + 1 : 0;
      item.textWidth = textWidth;
      item.iconWidth = item.icon ? item.icon.offsetWidth : 0;
      item.width = item.iconWidth + gap + textWidth;
      item.height = Math.max(item.icon ? item.icon.offsetHeight : 0, item.text ? item.text.offsetHeight : 0);
      item.element.style.setProperty('--invizi-chip-text-width', Math.ceil(textWidth) + 'px');
    });
  };

  /*
   * How far a point sits from the nearest bit of the flow, in viewBox units,
   * along with where on the path that nearest bit is. A chip has to clear the
   * band on every pass, not just the one it belongs to, which matters where the
   * loop doubles back beside itself.
   */
  RibbonIntro.prototype.clearanceAt = function (x, y) {
    var samples = this.clearanceSamples;
    var nearest = Infinity;
    var at = 0;
    for (var index = 0; index < samples.length; index++) {
      var distance = Math.hypot(samples[index].x - x, samples[index].y - y);
      if (distance < nearest) {
        nearest = distance;
        at = index / (samples.length - 1) * this.pathLength;
      }
    }
    this.nearestArc = at;
    return nearest;
  };

  /* Worst clearance across a chip's whole box, not just its centre. */
  RibbonIntro.prototype.boxClearance = function (x, y, halfWidth, halfHeight) {
    var worst = Infinity;
    for (var column = -1; column <= 1; column++) {
      for (var row = -1; row <= 1; row++) {
        if (!column && !row) continue;
        var room = this.clearanceAt(x + halfWidth * column, y + halfHeight * row);
        if (room < worst) worst = room;
      }
    }
    return worst - this.bandWidth / 2;
  };

  /*
   * The spot closest to the requested one where the chip's whole box clears the
   * band, stays inside the stage and keeps off the chips already placed. Returns
   * null when the chip is too big for any room the flow leaves.
   *
   * The requested point is taken as-is when it works, so a position set in the
   * editor is honoured exactly. Otherwise a grid over the stage is searched in
   * order of distance from it, rather than stepping outward along the path
   * normal: the flow crosses itself and runs parallel to itself, so the room a
   * chip needs is often a narrow corridor on the far side of another pass, which
   * an outward sweep walks straight over.
   */
  RibbonIntro.prototype.nudgeClear = function (x, y, box, needed, bounds, taken) {
    var self = this;
    var halfWidth = box.halfWidth;
    var halfHeight = box.halfHeight;
    // Chips can sit closer to each other than to the band, which they have to
    // where the gaps beside the flow are narrow.
    var apart = (this.variant.key === 'mobile' ? 10 : 16) / (this.artScale || 1);
    var fits = function (testX, testY) {
      if (testX - halfWidth < bounds.left || testX + halfWidth > bounds.right) return false;
      if (testY - halfHeight < bounds.top || testY + halfHeight > bounds.bottom) return false;
      if (taken.some(function (other) {
        return Math.abs(other.x - testX) < halfWidth + other.halfWidth + apart &&
          Math.abs(other.y - testY) < halfHeight + other.halfHeight + apart;
      })) return false;
      return self.boxClearance(testX, testY, halfWidth, halfHeight) >= needed;
    };
    var settle = function (spotX, spotY) {
      self.clearanceAt(spotX, spotY);
      return { x: spotX, y: spotY, halfWidth: halfWidth, halfHeight: halfHeight };
    };

    if (fits(x, y)) return settle(x, y);

    var spanX = bounds.right - bounds.left;
    var spanY = bounds.bottom - bounds.top;
    var columns = 12;
    var rows = 20;
    var candidates = [];
    for (var column = 0; column <= columns; column++) {
      for (var row = 0; row <= rows; row++) {
        var testX = bounds.left + spanX * column / columns;
        var testY = bounds.top + spanY * row / rows;
        candidates.push({
          x: testX,
          y: testY,
          away: Math.hypot(testX - x, testY - y)
        });
      }
    }
    candidates.sort(function (a, b) { return a.away - b.away; });
    for (var index = 0; index < candidates.length; index++) {
      if (fits(candidates[index].x, candidates[index].y)) {
        return settle(candidates[index].x, candidates[index].y);
      }
    }
    return null;
  };

  /*
   * Chips are placed once per layout, at the position set in the editor, so
   * scrolling only ever toggles a class. They may sit over the band.
   */
  RibbonIntro.prototype.layoutItems = function () {
    if (!this.items.length || !this.geometryPath || !this.variant) return;
    var scale = this.artScale || 1;
    var mobile = this.variant.key === 'mobile';
    var margin = 12 / scale;
    var stageLeft = -this.artOffsetX / scale;
    var stageTop = -this.artOffsetY / scale;
    var stageWidth = this.stage.clientWidth / scale;
    var stageHeight = this.stage.clientHeight / scale;
    var bounds = {
      left: stageLeft + margin,
      right: stageLeft + stageWidth - margin,
      top: stageTop + margin,
      bottom: stageTop + stageHeight - margin
    };

    this.items.forEach(function (item) {
      var want = mobile ? item.want.mobile : item.want.desktop;
      var box = { halfWidth: item.width / scale / 2, halfHeight: item.height / scale / 2 };
      var x = Math.min(
        Math.max(stageLeft + stageWidth * want.x, bounds.left + box.halfWidth),
        bounds.right - box.halfWidth
      );
      var y = Math.min(
        Math.max(stageTop + stageHeight * want.y, bounds.top + box.halfHeight),
        bounds.bottom - box.halfHeight
      );

      item.placed = true;
      item.revealed = null;
      item.screenY = this.artOffsetY + y * scale - item.height / 2;
      item.element.classList.remove('is-animated', 'is-unplaced');
      item.element.style.transform = 'translate3d(' +
        (this.artOffsetX + (x - box.halfWidth) * scale).toFixed(1) + 'px,' +
        item.screenY.toFixed(1) + 'px,0)';
    }, this);
  };

  /*
   * Y runs backwards through the loop, so the raw path cannot map scroll to
   * progress. The guide is a monotone rewrite of the path's Y profile: descending
   * runs track it one to one and keep the tip pinned near the reveal line, while
   * the loop-back and the level run-off are given a real share of scroll by the
   * step floor. Rescaling to the authored finish depth is what buys the draw its
   * scroll: the span between the first Y and that depth, in viewBox units, is the
   * whole of the scroll the flow gets, so pulling the finish shallower speeds the
   * entire draw up rather than just its end.
   */
  RibbonIntro.prototype.buildRevealGuide = function () {
    var samples = this.pathSamples;
    var count = samples.length;
    if (!count) return;
    var startY = samples[0].y;
    var endY = (this.variant && this.variant.finishY) || samples[count - 1].y;
    var averageStep = Math.max(0.25, (endY - startY) / Math.max(1, count - 1));
    var minimumStep = averageStep * 0.35;
    var maximumStep = averageStep * 5;
    var guideY = [startY];
    for (var index = 1; index < count; index++) {
      var previousGuide = guideY[index - 1];
      guideY.push(Math.max(
        previousGuide + minimumStep,
        Math.min(samples[index].y, previousGuide + maximumStep)
      ));
    }
    var span = guideY[count - 1] - startY;
    var normalise = span > 0 ? (endY - startY) / span : 1;
    this.revealGuide = guideY.map(function (value, index) {
      return {
        guideY: startY + (value - startY) * normalise,
        progress: samples[index].progress
      };
    });
  };

  RibbonIntro.prototype.progressAtGuideY = function (targetY) {
    var guide = this.revealGuide;
    if (!guide.length || targetY <= guide[0].guideY) return 0;
    if (targetY >= guide[guide.length - 1].guideY) return 1;
    var low = 0;
    var high = guide.length - 1;
    while (low < high) {
      var middle = Math.floor((low + high) / 2);
      if (guide[middle].guideY < targetY) low = middle + 1;
      else high = middle;
    }
    var next = guide[low];
    var previous = guide[Math.max(0, low - 1)];
    var span = Math.max(0.001, next.guideY - previous.guideY);
    var mix = clamp01((targetY - previous.guideY) / span);
    return previous.progress + (next.progress - previous.progress) * mix;
  };

  /*
   * A single stroked path merges its own self-overlap, so the loop crossing has
   * no seam until the arc range past crossStart is painted again on top.
   *
   * Each pass is drawn three times, and the shadow sub-stroke is the one pushed
   * down the page, so its own cap is the only thing that can show past the band
   * it sits under: a grey crescent riding the growing tip from the base pass's
   * round cap, and a straight line cut across the finished end by the over
   * pass's butt cap. Holding the shadow a short arc behind the outline and fill,
   * at both ends, keeps every cap tucked underneath.
   */
  RibbonIntro.prototype.setPathReveal = function (progress) {
    /*
     * Skip the write when nothing would change, so scroll dust stops
     * invalidating paint. Finer than the bloom's step because this drives the
     * drawing tip: at 1/1000 a step is under two device pixels of arc, where
     * the bloom's 1/200 would visibly stutter the growing end.
     */
    var revealed = Math.round(clamp01(progress) * 1000) / 1000;
    if (revealed === this.pathRevealStep) return;
    this.pathRevealStep = revealed;

    var inset = this.shadowInset;
    var lead = String(1 - revealed);
    if (this.outline) this.outline.style.strokeDashoffset = lead;
    if (this.path) this.path.style.strokeDashoffset = lead;
    if (this.shadow) this.shadow.style.strokeDashoffset = String(1 - Math.max(0, revealed - inset));

    var crossStart = this.crossStart;
    var dash = Math.max(0, revealed - crossStart) + ' 1';
    var overOffset = String(-crossStart);
    this.overPaths.forEach(function (path) {
      if (!path || path === this.overShadow) return;
      path.style.strokeDasharray = dash;
      path.style.strokeDashoffset = overOffset;
    }, this);
    if (this.overShadow) {
      this.overShadow.style.strokeDasharray = Math.max(0, revealed - crossStart - inset * 2) + ' 1';
      this.overShadow.style.strokeDashoffset = String(-(crossStart + inset));
    }
  };

  /* The pop itself is CSS; each chip appears once its top clears the lower 10%. */
  RibbonIntro.prototype.updateItemReveal = function (forceAll) {
    var stageTop = this.stage.getBoundingClientRect().top;
    var line = stableViewportHeight() * 0.9;
    this.items.forEach(function (item) {
      if (!item.placed) return;
      var reached = forceAll || stageTop + item.screenY <= line;
      if (reached === item.revealed) return;
      item.revealed = reached;
      item.element.classList.toggle('is-animated', reached);
    });
  };

  RibbonIntro.prototype.readTargets = function () {
    var stageRect = this.stage.getBoundingClientRect();
    var revealLine = stableViewportHeight() * 0.9;
    var scale = this.artScale || 1;
    var artTop = stageRect.top + this.artOffsetY;
    /*
     * The takeover is triggered from an authored point on the flow rather than
     * its end, because the run-off deliberately carries on past the side of the
     * screen so the rounded cap is never seen. It keeps drawing off-screen for
     * the whole takeover.
     */
    var handoffY = artTop + this.variant.handoffY * scale;
    var pathProgress = this.progressAtGuideY((revealLine - artTop) / scale);

    /*
     * The takeover runs from the scroll where that point crosses the reveal line
     * to a point past where the heading it hands off to enters the viewport.
     * Both are absolute document positions, so the span is a layout constant.
     *
     * Past, not level with: the heading's own climb is what paces its entry, and
     * that climb only begins once it is in view, so a takeover ending exactly
     * there leaves the heading pinned at nothing for the whole of it. Running on
     * gives the two a stretch of overlap, which is what makes the heading rise
     * while the flow is still fading. Scenes with no heading to hand off to
     * fall back to a tenth of a viewport.
     */
    var span = stableViewportHeight() * 0.1;
    if (this.options.handoffEnd) {
      var startScroll = window.scrollY + handoffY - revealLine;
      var endScroll = this.options.handoffEnd() + stableViewportHeight() * HANDOFF_OVERLAP;
      if (endScroll > startScroll) span = endScroll - startScroll;
    }
    var handoffProgress = easeInOut(clamp01((revealLine - handoffY) / Math.max(1, span)));
    return { path: pathProgress, handoff: handoffProgress };
  };

  RibbonIntro.prototype.render = function (pathProgress, handoffProgress) {
    this.setPathReveal(pathProgress);
    /*
     * The flow used to fade out over the end of the takeover. It now scrolls away
     * at full strength instead, so the benefits stay legible right up to the point
     * they leave the frame. The handoff still runs — it is what paces the film
     * heading's entrance — it just no longer drives opacity.
     */
    if (this.lastContentOpacity !== '1') {
      this.lastContentOpacity = '1';
      this.root.style.setProperty('--invizi-ribbon-content-opacity', '1');
    }
    this.updateItemReveal(false);
    var progressAttr = pathProgress.toFixed(3);
    var handoffAttr = handoffProgress.toFixed(3);
    if (progressAttr !== this.lastProgressAttr) {
      this.lastProgressAttr = progressAttr;
      this.root.setAttribute('data-ribbon-progress', progressAttr);
    }
    if (handoffAttr !== this.lastHandoffAttr) {
      this.lastHandoffAttr = handoffAttr;
      this.root.setAttribute('data-ribbon-handoff', handoffAttr);
    }
    if (this.options.onProgress) this.options.onProgress(pathProgress, handoffProgress);
  };

  RibbonIntro.prototype.update = function (time, immediate) {
    if (!this.stage || !this.path || this.isStatic()) return false;
    var targets = this.readTargets();
    /*
     * Out of frame the flow only has to agree with where the page is. It is
     * settled outright when it disagrees and left alone when it does not, so a
     * scroll that clears the whole thing in one jump, or a deep link past it,
     * cannot leave it frozen half drawn. Damping there would only animate
     * something nobody can see.
     */
    if (!this.inView && this.currentProgress != null) {
      if (this.currentProgress === targets.path && this.currentHandoff === targets.handoff) return false;
      immediate = true;
    }
    if (this.currentProgress == null || immediate) {
      this.currentProgress = targets.path;
      this.currentHandoff = targets.handoff;
    } else {
      var deltaTime = Math.min(50, Math.max(1, time - (this.lastFrameTime || time - 16.67)));
      // Lenis already interpolates the scroll position, so this only takes the
      // edge off a raw jump. Damping harder here would stack two lags.
      var alpha = 1 - Math.pow(0.45, deltaTime / 16.67);
      this.currentProgress += (targets.path - this.currentProgress) * alpha;
      this.currentHandoff += (targets.handoff - this.currentHandoff) * alpha;
      if (Math.abs(targets.path - this.currentProgress) < 0.0002) this.currentProgress = targets.path;
      if (Math.abs(targets.handoff - this.currentHandoff) < 0.0002) this.currentHandoff = targets.handoff;
    }
    this.lastFrameTime = time;
    this.render(this.currentProgress, this.currentHandoff);
    return Math.abs(targets.path - this.currentProgress) >= 0.0002 ||
      Math.abs(targets.handoff - this.currentHandoff) >= 0.0002;
  };

  RibbonIntro.prototype.tick = function () {
    this.update(performance.now(), true);
  };

  RibbonIntro.prototype.requestTick = function () {
    if (!this.inView || this.isStatic()) return;
    if (this.options.requestFrame) this.options.requestFrame();
  };

  RibbonIntro.prototype.onResize = function () {
    var self = this;
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(function () { self.setup(); }, 150);
  };

  RibbonIntro.prototype.destroy = function () {
    clearTimeout(this.resizeTimer);
    if (this.armObserver) this.armObserver.disconnect();
    if (this.observer) this.observer.disconnect();
    if (this.onPreferenceChange) {
      if (this.motionQuery && this.motionQuery.removeEventListener) this.motionQuery.removeEventListener('change', this.onPreferenceChange);
      if (this.dataQuery && this.dataQuery.removeEventListener) this.dataQuery.removeEventListener('change', this.onPreferenceChange);
    }
    this.restoreArts();
    this.root.classList.remove('is-ready');
    this.root.setAttribute('data-motion', 'static');
  };

  function OkendoHydrator(root, stack) {
    this.root = root;
    this.stack = stack;
    this.done = false;
    this.config = {};
    try {
      var node = root.querySelector('[data-rv-okendo]');
      if (node) this.config = JSON.parse(node.textContent || '{}');
    } catch (error) {
      this.config = {};
    }
  }

  OkendoHydrator.prototype.mount = function () {
    var self = this;
    this.observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || self.done) return;
      self.done = true;
      self.observer.disconnect();
      self.hydrate();
    }, { rootMargin: '400px' });
    this.observer.observe(this.root);
  };

  OkendoHydrator.prototype.subscriberId = function () {
    if (this.config.subscriberId) return String(this.config.subscriberId).trim();
    var ids = ['oke-reviews-settings', 'okeReferralSettings', 'oke-loyalty-settings'];
    for (var index = 0; index < ids.length; index++) {
      var node = document.getElementById(ids[index]);
      if (!node) continue;
      try {
        var data = JSON.parse(node.textContent || '');
        if (data.subscriberId) return String(data.subscriberId).trim();
      } catch (error) { /* continue */ }
    }
    return '';
  };

  OkendoHydrator.prototype.hydrate = function () {
    var id = this.subscriberId();
    if (!id) return;
    var self = this;
    var limit = this.config.cardsToShow || 5;
    var productIds = (this.config.productIds || []).map(function (value) {
      return String(value || '').replace(/^shopify-/, '').trim();
    }).filter(Boolean);

    /*
     * "Limit reviews to products" is a filter, not a card count. Fetching the
     * store-wide feed and keeping matches often yields one hit per product in
     * the latest page (2 products → 2 cards) even when Reviews to show is 5.
     * When products are set, ask Okendo per product and fill up to cardsToShow.
     */
    var requests = productIds.length
      ? productIds.map(function (productId) {
          return self.fetchReviews(
            'https://api.okendo.io/v1/stores/' + encodeURIComponent(id) +
              '/products/' + encodeURIComponent(productId) +
              '/reviews?limit=' + Math.min(25, Math.max(limit, 8)) + '&orderBy=date%20desc'
          );
        })
      : [
          self.fetchReviews(
            'https://api.okendo.io/v1/stores/' + encodeURIComponent(id) +
              '/reviews?limit=25&orderBy=date%20desc'
          )
        ];

    Promise.all(requests)
      .then(function (pages) {
        var aggregate = null;
        var pools = pages.map(function (page) {
          if (!page) return [];
          if (!aggregate) aggregate = page.aggregate || page.aggregateRating || page.summary || null;
          return self.qualifyingReviews(page);
        });
        var reviews = productIds.length ? self.interleave(pools, limit) : pools[0].slice(0, limit);
        /*
         * The cards are real reviews rendered by Liquid; this is only freshness.
         * Swap them only when there are at least as many, and only while the stack
         * is still below the viewport, so nobody sees the content change (R2).
         */
        var serverCards = Number(self.config.serverCards) || 0;
        if (!serverCards || reviews.length < serverCards) return;
        if (self.root.getBoundingClientRect().top <= window.innerHeight) return;
        self.apply(reviews.slice(0, serverCards), aggregate);
      })
      .catch(function () {});
  };

  OkendoHydrator.prototype.fetchReviews = function (url) {
    // No custom headers: Okendo's CORS preflight does not allow them, and the
    // request then fails outright ("Failed to fetch").
    return fetch(url)
      .then(function (response) { return response.ok ? response.json() : null; });
  };

  /* Reviews long enough to fill a card; optional handle filter for store-wide feeds. */
  OkendoHydrator.prototype.qualifyingReviews = function (data) {
    var reviews = Array.isArray(data.reviews) ? data.reviews : Array.isArray(data.data) ? data.data : Array.isArray(data) ? data : [];
    var minimumWords = this.config.minWords || 10;
    var minimumRating = this.config.minRating || 1;
    var language = String(this.config.locale || '').split('-')[0].toLowerCase();
    var handles = (this.config.productHandles || []).map(function (handle) {
      return String(handle || '').toLowerCase();
    }).filter(Boolean);
    var productIds = (this.config.productIds || []).map(function (value) {
      return String(value || '').replace(/^shopify-/, '').trim();
    }).filter(Boolean);
    /* Per-product endpoints are already scoped; only filter handles on store-wide. */
    var filterByHandle = !productIds.length && handles.length;
    var output = [];

    for (var index = 0; index < reviews.length; index++) {
      var review = reviews[index];
      var body = String(review.body || review.content || review.reviewText || review.text || '').trim();
      if (!body || body.split(/\s+/).length < minimumWords) continue;
      if ((Number(review.rating) || 0) < minimumRating) continue;
      /* Okendo syndicates reviews from the other stores; keep the storefront's language. */
      var reviewLanguage = String(review.languageCode || '').split('-')[0].toLowerCase();
      if (language && reviewLanguage && reviewLanguage !== language) continue;
      if (filterByHandle) {
        var product = review.product || review.productInfo || {};
        var handle = String(review.productHandle || product.handle || '').toLowerCase();
        var title = String(review.productName || product.title || product.name || '').toLowerCase();
        var matches = handles.some(function (candidate) {
          return candidate && (candidate === handle || handle.indexOf(candidate) !== -1 || title.indexOf(candidate) !== -1);
        });
        if (!matches) continue;
      }
      output.push(review);
    }
    return output;
  };

  /* Round-robin across product pools so 2 products still fill 5 cards evenly. */
  OkendoHydrator.prototype.interleave = function (pools, limit) {
    var queues = pools.map(function (pool) { return pool.slice(); });
    var output = [];
    while (output.length < limit) {
      var added = false;
      for (var index = 0; index < queues.length && output.length < limit; index++) {
        if (!queues[index].length) continue;
        output.push(queues[index].shift());
        added = true;
      }
      if (!added) break;
    }
    return output;
  };

  /*
   * PERF-07 SF-04: the fresh reviews replace the server-rendered ones only while the
   * stack is off screen, so no card changes under the reader.
   */
  OkendoHydrator.prototype.apply = function (reviews, aggregate) {
    var self = this;
    var rect = this.root.getBoundingClientRect();
    if (rect.bottom > 0 && rect.top < window.innerHeight && 'IntersectionObserver' in window) {
      if (this.pending) this.pending.disconnect();
      this.pending = new IntersectionObserver(function (entries) {
        if (entries[entries.length - 1].isIntersecting) return;
        self.pending.disconnect();
        self.pending = null;
        self.applyNow(reviews, aggregate);
      });
      this.pending.observe(this.root);
      return;
    }
    this.applyNow(reviews, aggregate);
  };

  OkendoHydrator.prototype.applyNow = function (reviews, aggregate) {
    var filtered = Array.isArray(reviews) ? reviews : [];
    if (!filtered.length) return;
    var cards = Array.prototype.slice.call(this.root.querySelectorAll('[data-rv-card]:not([data-cta])'));
    var verifiedLabel = this.config.verifiedLabel || 'Verified buyer';
    cards.forEach(function (card, cardIndex) {
      if (!filtered[cardIndex]) {
        card.style.display = 'none';
        return;
      }
      card.style.display = '';
      card.innerHTML = this.render(filtered[cardIndex], verifiedLabel);
    }, this);

    if (aggregate && this.config.aggregateTemplate) {
      var total = aggregate.reviewCount || aggregate.count || aggregate.totalReviews || aggregate.total;
      var count = this.root.querySelector('[data-rv-count]');
      if (total != null && count) count.textContent = String(this.config.aggregateTemplate).replace(/\[count\]/g, String(total));
    }

    this.stack.cards = Array.prototype.slice.call(this.root.querySelectorAll('[data-rv-card]')).filter(function (card) {
      return card.style.display !== 'none';
    });
    // Cards already have geometry; only remeasure offsets, don't rebuild the scene.
    if (this.stack.relayout) this.stack.relayout();
    else this.stack.setup();
  };

  OkendoHydrator.prototype.render = function (review, verifiedLabel) {
    var body = escapeHtml(review.body || review.content || review.reviewText || review.text || '');
    var reviewer = review.reviewer || review.author || {};
    var name = escapeHtml(reviewer.displayName || reviewer.name || review.authorName || review.name || 'Verified customer');
    var product = review.product || review.productInfo || {};
    var url = review.productUrl || product.url || product.productUrl || '';
    var title = escapeHtml(review.productName || product.title || product.name || '');
    var rating = Math.max(0, Math.min(5, Math.round(Number(review.rating || review.stars || review.score) || 5)));
    var productLink = url && title
      ? '<a class="rv__product t-std-text-medium" href="' + escapeHtml(url) + '">' + title + '<span aria-hidden="true">\u2192</span></a>'
      : '';
    var headingClass = this.root.closest('.invizi-scene--nundies') ? 't-nundies-h3' : 't-invizi-h3';

    return '<blockquote class="rv__quote ' + headingClass + '"><span class="rv__mark">\u201c</span>' + body + '<span class="rv__mark">\u201d</span></blockquote>' +
      '<div class="rv__meta"><div class="rv__who"><span class="rv__name t-std-text-large">' + name + '</span>' +
      (reviewer.isVerified ? '<span class="rv__verified t-std-text-large">' + escapeHtml(verifiedLabel) + '</span>' : '') + '</div>' +
      this.stars(rating) + '</div>' + productLink;
  };

  // Mirrors snippets/rating-stars.liquid: Nundies routes use the brand sprite,
  // everything else the peach glyph. Without this the hydrated cards drop back
  // to peach stars the moment Okendo replaces the server-rendered markup.
  OkendoHydrator.prototype.stars = function (rating) {
    var nundiesSrc = this.config.nundiesStarsSrc;
    if (nundiesSrc && this.root.closest('.invizi-scene--nundies')) {
      var fill = Math.max(0, Math.min(100, (rating / 5) * 100));
      return '<span class="nundies-rating-stars" role="img" aria-label="Rated ' + rating + ' out of 5"' +
        ' style="--nundies-rating-height:' + RV_STAR_SIZE + 'px;--nundies-rating-fill:' + fill + '%">' +
        '<img class="nundies-rating-stars__image nundies-rating-stars__image--empty" src="' + escapeHtml(nundiesSrc) + '" width="192" height="45" alt="">' +
        '<span class="nundies-rating-stars__fill" aria-hidden="true">' +
        '<img class="nundies-rating-stars__image" src="' + escapeHtml(nundiesSrc) + '" width="192" height="45" alt="">' +
        '</span></span>';
    }

    var output = '<span class="rv-stars" role="img" aria-label="Rated ' + rating + ' out of 5" style="--rv-star-size:' + RV_STAR_SIZE + 'px">';
    for (var index = 0; index < 5; index++) {
      output += '<span class="rv-stars__unit"><svg class="rv-stars__empty" viewBox="0 0 20 20" aria-hidden="true"><path d="' + STAR_PATH + '" fill="currentColor"></path></svg>';
      if (index < rating) output += '<span class="rv-stars__fill"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + STAR_PATH + '" fill="currentColor"></path></svg></span>';
      output += '</span>';
    }
    return output + '</span>';
  };

  OkendoHydrator.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
    if (this.pending) this.pending.disconnect();
  };

  function ScrollStory(scene) {
    this.scene = scene;
    this.raf = 0;
    var ribbonRoot = scene.querySelector('[data-ribbon-intro]');
    var videoRoot = scene.querySelector('[data-video-stack]');
    var reviewRoot = scene.querySelector('[data-rv-section]');
    this.ribbonRoot = ribbonRoot;
    this.videoRoot = videoRoot;
    /*
     * Armed from script, so the start state only exists once something is around to
     * finish it. If this file never runs the heading is simply visible.
     */
    if (videoRoot) videoRoot.classList.add('is-title-armed');
    this.reviewRoot = reviewRoot;
    this.ribbonHandoff = ribbonRoot ? 0 : 1;
    this.headingScroll = 0;
    var self = this;
    /*
     * The choreographed entrance is gated on the ribbon handoff resolving. If it
     * never does — a deep link landing past it, a scene that stalls — the heading
     * would sit at opacity 0 for good. Being on screen is reason enough to show,
     * so whichever comes first wins and the heading can never be stranded hidden.
     */
    var filmTitle = videoRoot ? videoRoot.querySelector('[data-stack-title]') : null;
    if (filmTitle && 'IntersectionObserver' in window) {
      this.titleFallback = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        self.enterFilmTitle();
      }, { threshold: 0.2 });
      this.titleFallback.observe(filmTitle);
    }
    this.ribbon = ribbonRoot ? new RibbonIntro(ribbonRoot, {
      onProgress: function (_, handoffProgress) { self.updateRibbonHandoff(handoffProgress); },
      onStatic: function () { self.setStaticScene(); },
      // Left static for this page view: reduced motion keeps the whole scene still, as
      // before; otherwise the heading needs no handoff and enters on its own travel.
      onStaticView: function (reduced) {
        if (reduced) {
          self.setStaticScene();
          return;
        }
        self.ribbonHandoff = 1;
        self.setFilmTitleEnter();
      },
      requestFrame: function () { self.requestTick(); },
      handoffEnd: videoRoot ? function () { return self.headingEntryScroll(); } : null
    }) : null;
    this.videoStack = videoRoot ? new CardStack(videoRoot, {
      video: true,
      foldWithEnter: true,
      stageSelector: '[data-stack-stage]',
      titleSelector: '[data-stack-title]',
      foldSelector: '[data-stack-fold]',
      cardSelector: '[data-stack-card]',
      onProgress: function (progress, stageHeight, stack) {
        self.filmTitleLift = stack.titleLift;
        self.setFilmTitleEnter();
      },
      onLayout: function (stack) { self.measureHeadingEntry(stack); },
      onStatic: function () { self.setStaticScene(); },
      // Armed after a static start (it was on screen, then went below): the heading
      // gets its entrance back, since it is out of view again.
      onArm: function () {
        if (!self.titleEntered) videoRoot.classList.add('is-title-armed');
      },
      requestFrame: function () { self.requestTick(); }
    }) : null;
    this.reviewStack = reviewRoot ? new CardStack(reviewRoot, {
      stageSelector: '[data-rv-stage]',
      titleSelector: '[data-rv-title]',
      foldSelector: '[data-rv-fold]',
      cardSelector: '[data-rv-card]',
      onStatic: function () { self.setStaticScene(); },
      requestFrame: function () { self.requestTick(); }
    }) : null;
    this.okendo = reviewRoot && this.reviewStack ? new OkendoHydrator(reviewRoot, this.reviewStack) : null;
  }

  ScrollStory.prototype.setStaticScene = function () {
    if (!this.videoRoot) return;
    this.titleEntered = false;
    this.videoRoot.classList.remove('is-title-armed', 'is-title-entered');
    this.videoRoot.style.removeProperty('--invizi-films-title-enter');
    this.videoRoot.style.removeProperty('--invizi-films-title-opacity');
  };

  ScrollStory.prototype.updateRibbonHandoff = function (handoffProgress) {
    this.ribbonHandoff = clamp01(handoffProgress);
    this.setFilmTitleEnter();
  };

  /*
   * The document position at which the film heading first appears at the bottom
   * of the viewport. The ribbon uses it as the end of its takeover, so the two
   * meet instead of leaving a stretch of scrolling where nothing moves. It is a
   * layout constant, so it is measured with the stack rather than per frame.
   */
  ScrollStory.prototype.measureHeadingEntry = function (stack) {
    if (!stack || !stack.title) {
      this.headingScroll = 0;
      return;
    }
    var rootTop = stack.root.getBoundingClientRect().top + window.scrollY;
    this.headingScroll = rootTop + stack.titleOffsetTop - stableViewportHeight();
  };

  ScrollStory.prototype.headingEntryScroll = function () {
    return this.headingScroll || 0;
  };

  /*
   * The film heading rises in as the ribbon hands over. The handoff gates it,
   * so it cannot start before the takeover is halfway through, and the
   * heading's own travel toward its resting position paces it, because the
   * handoff finishes while the heading is still below the fold.
   */
  /*
   * The heading used to be lifted and faded by writing two custom properties every
   * frame, scrubbed from scroll position. On iOS Safari the compositor scrolls the
   * sticky stage while script re-positions the heading inside it a frame or two
   * late, and that disagreement is the jitter — it cannot be damped away, because
   * the two are driven by different clocks.
   *
   * So scroll now only decides WHEN the entrance starts. Once the handoff and the
   * heading's own travel agree it is due, a class goes on and CSS runs the move on
   * its own timeline, where the compositor owns it end to end. One-shot: scrolling
   * back up no longer rewinds it, which also stops the heading flickering at the
   * threshold.
   */
  ScrollStory.prototype.enterFilmTitle = function () {
    if (!this.videoRoot || this.titleEntered) return;
    this.titleEntered = true;
    this.videoRoot.classList.add('is-title-entered');
    if (this.titleFallback) this.titleFallback.disconnect();
    if (this.videoStack && this.videoStack.fold) this.videoStack.fold.unfold();
  };

  ScrollStory.prototype.setFilmTitleEnter = function () {
    if (!this.videoRoot || !this.ribbonRoot || this.titleEntered) return;
    var gate = clamp01((this.ribbonHandoff - 0.45) / 0.55);
    if (Math.min(gate, this.filmTitleLift || 0) <= 0.02) return;
    this.enterFilmTitle();
  };

  ScrollStory.prototype.requestTick = function () {
    if (this.raf) return;
    var self = this;
    this.raf = requestAnimationFrame(function (time) {
      self.raf = 0;
      var keepRunning = false;
      // Driven whether or not the flow is on screen: out of frame it settles
      // itself against the scroll position and costs nothing once it agrees.
      if (self.ribbon) keepRunning = self.ribbon.update(time, false) || keepRunning;
      // Tick the film stack during the ribbon handoff too: titleLift is what
      // paces the heading's entrance, and the stack's own observer only starts
      // once it is already on screen, which is after the handoff has finished.
      if (
        self.videoStack &&
        !self.videoStack.isStatic() &&
        (self.videoStack.inView || (self.ribbonRoot && self.ribbonHandoff > 0))
      ) {
        self.videoStack.tick();
      }
      if (self.reviewStack && self.reviewStack.inView && !self.reviewStack.isStatic()) self.reviewStack.tick();
      if (keepRunning) self.requestTick();
    });
  };

  ScrollStory.prototype.mount = function () {
    if (this.ribbon) this.ribbon.mount();
    if (this.videoStack) this.videoStack.mount();
    if (this.reviewStack) this.reviewStack.mount();
    if (this.okendo) this.okendo.mount();
    var self = this;
    this.onScroll = function () {
      self.requestTick();
    };
    this.onResize = function () {
      if (!viewportChanged()) return;
      if (self.ribbon) self.ribbon.onResize();
      if (self.videoStack) self.videoStack.onResize();
      if (self.reviewStack) self.reviewStack.onResize();
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
  };

  ScrollStory.prototype.destroy = function () {
    if (this.raf) cancelAnimationFrame(this.raf);
    if (this.titleFallback) this.titleFallback.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    if (this.okendo) this.okendo.destroy();
    if (this.reviewStack) this.reviewStack.destroy();
    if (this.videoStack) this.videoStack.destroy();
    if (this.ribbon) this.ribbon.destroy();
  };

  function mountScene(scene) {
    if (!scene || scene.__invizi) return;
    var story = new ScrollStory(scene);
    scene.__invizi = story;
    try {
      story.mount();
    } catch (error) {
      if (window.console && console.warn) console.warn('[invizi-films] mount failed', error);
      scene.__invizi = null;
    }
  }

  function unmountScene(scene) {
    if (!scene || !scene.__invizi) return;
    scene.__invizi.destroy();
    scene.__invizi = null;
  }

  function boot() {
    var scenes = Array.prototype.slice.call(document.querySelectorAll('[data-invizi-scene]'));
    if (!scenes.length) return;

    // Mount immediately if already near (deep link / restored scroll), otherwise
    // wait until the scene is within ~1.5 viewports so hero-phase TBT stays clear
    // of ribbon getTotalLength / getPointAtLength / nudgeClear work.
    var mountNow = function (scene) {
      if (scene.__inviziDeferred) {
        scene.__inviziDeferred.disconnect();
        scene.__inviziDeferred = null;
      }
      mountScene(scene);
    };

    if (!('IntersectionObserver' in window)) {
      scenes.forEach(mountNow);
      return;
    }

    scenes.forEach(function (scene) {
      var alreadyNear = false;
      try {
        var rect = scene.getBoundingClientRect();
        alreadyNear = rect.top < stableViewportHeight() * 2.5;
      } catch (error) { /* ignore */ }
      if (alreadyNear || (window.location.hash && scene.querySelector(window.location.hash))) {
        mountNow(scene);
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        mountNow(scene);
      }, { rootMargin: '150% 0px' });
      scene.__inviziDeferred = observer;
      observer.observe(scene);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  function sceneFromEvent(event) {
    var target = event && event.target;
    if (!target) return null;
    if (target.matches && target.matches('[data-invizi-scene]')) return target;
    return target.querySelector('[data-invizi-scene]') || target.closest('[data-invizi-scene]');
  }

  document.addEventListener('shopify:section:load', function (event) {
    var scene = sceneFromEvent(event);
    if (!scene) return;
    if (scene.__inviziDeferred) {
      scene.__inviziDeferred.disconnect();
      scene.__inviziDeferred = null;
    }
    unmountScene(scene);
    mountScene(scene);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unmountScene(sceneFromEvent(event));
  });

  document.addEventListener('shopify:block:select', function (event) {
    var target = event && event.target;
    if (!target || !target.closest) return;
    var card = target.closest('[data-stack-card],[data-rv-card]');
    if (card) card.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });

  window.InviziScrollStory = ScrollStory;
})();
